module.exports = __webpack_public_path__ + "static/IntegromatWH-d5cf474a6f57d34fa6003f8735c0aabd.png";